import Wizard, { WizardStepConfig } from "@components/shared/Wizard/Wizard";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/primitives/dialog";
import { useEffect, useState } from "react";
import StartStep from "./StartStep";
import PasswordStep from "./PasswordStep";
import WordsStep from "./WordsStep";
import useAuthSession from "@/middleware/hooks/useAuthSession";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { RECOVERY_DELAY_KEYS } from "@/config/constants";
import { useAuthState } from "@/zustand/AuthState";
import ConfirmPhraseEncryptStep from "./ConfirmPhraseEncryptStep";

export default function RecoveryKeyWizard() {
  const [open, setOpen] = useState(false);
  const encryptedPassword = useAuthState((s) => s.encryptedPassword);

  const { isLoggedIn } = useAuthSession();

  const [recoveryKeyRemind] = useLocalStorage<number>(
    RECOVERY_DELAY_KEYS.STORAGE_KEY,
    0,
  );

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    if (encryptedPassword && encryptedPassword !== "") {
      return;
    }

    const shouldShow = Date.now() - recoveryKeyRemind >= 0;
    if (!shouldShow) {
      return;
    }
    const timer = setTimeout(
      () => setOpen(true),
      RECOVERY_DELAY_KEYS.INITIAL_SHOW_DELAY,
    );
    return () => clearTimeout(timer);
  }, [isLoggedIn, recoveryKeyRemind, encryptedPassword]);

  const steps: WizardStepConfig[] = [
    {
      name: "Start",
      dataKey: "start",
      component: StartStep,
    },
    {
      name: "Password",
      dataKey: "password",
      component: PasswordStep,
    },
    {
      name: "Words",
      dataKey: "words",
      component: WordsStep,
    },
    {
      name: "Confirm Phrase",
      dataKey: "confirmPhrase",
      component: ConfirmPhraseEncryptStep,
    },
  ];
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="h-full min-w-full p-6 md:h-auto md:min-w-[43rem]"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogTitle className="hidden" />
        <DialogDescription className="hidden" />
        <Wizard steps={steps} onClose={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}
